import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getJusPaymentStatusLoad } from '../../actionCreators/checkout';
import getSetCookie from '../../cookie';
import CheckoutHeader from '../../desktop/components/Checkout/CheckoutHeader/CheckoutHeader';
import './JusPayment.scss';

const ConfirmJusPayment = React.memo(props => {
  const { jusPaymentStatusLoading, jusPaymentStatusData } = useSelector(x => x.checkout);
  const { localeInfo } = useSelector(state => state.common);
  const { SOME_ERROR_OCCURED_PLEASE_TRY_AGAIN, LDR, PLEASE_WAIT_WHILE_CONFIRM_YOUR_PAYMENT } =
    useSelector(x => x.locale);
  const dispatch = useDispatch();

  useEffect(() => {
    const orderId = getSetCookie.getCookie('orderId');
    if (orderId) {
      dispatch(getJusPaymentStatusLoad({ orderId }));
    }
  }, []);

  useEffect(() => {
    if (jusPaymentStatusData) {
      const { history } = props;
      if (jusPaymentStatusData?.status === 'SUCCESS') {
        setTimeout(() => {
          history.push('/checkout/onepage/success');
        }, 3000);
      } else {
        setTimeout(() => {
          history.push('/checkout/onepage/retrypayment');
        }, 3000);
      }
    }
  }, [jusPaymentStatusData]);

  return (
    <div
      className={`juspay-confirm-container qr-payment-container ${
        process.env.CLIENT_TYPE === 'desktop' ? 'display-flex' : ''
      } flex-column`}
    >
      {jusPaymentStatusLoading && (
        <div className="qr-loader status">
          <img alt={LDR} src="https://static.lenskart.com/media/desktop/img/loader.gif" />
        </div>
      )}
      <CheckoutHeader
        client={process.env.CLIENT_TYPE}
        logoCenter="https://static.lenskart.com/media/desktop/img/checkout_Logo.png"
        pathPrefix={localeInfo.pathPrefix}
      />
      <div className="fw-bold mr-t20 text-center fs20">
        {PLEASE_WAIT_WHILE_CONFIRM_YOUR_PAYMENT}
      </div>
      {jusPaymentStatusData?.message && (
        <div className="fw-bold mr-t20 text-center fs14">
          {SOME_ERROR_OCCURED_PLEASE_TRY_AGAIN}: {jusPaymentStatusData?.message}
        </div>
      )}
    </div>
  );
});

export default ConfirmJusPayment;
